import { HasId } from '../interfaces';
import { ScoreType } from './ScoreType';
import { Characteristic } from './Characteristic';
import { Language } from './Language';
import { SurveyVersion } from './SurveyVersion';

export class StyleConstraint implements HasId {
    public id: number;
    public scoreTypeLeft: ScoreType;
    public scoreTypeRight: ScoreType;
}

export class StyleCharacteristicForce implements HasId {
    public id: number;
    public characteristic: Characteristic;
    public characteristicId: number;
}

export class StyleText implements HasId {
    public id: number;
    public styleTextType: string;
    public value: string;
    public keyName: string;
    public sort: number;
    public languageId: number;
    public language: Language;  
    public showModal: boolean;
}

export class StyleTag implements HasId {
    public id: number;
    public value: string;
    public languageId: number;
    public language: Language;
}

export class Style implements HasId {
    public id: number;
    public name: string;
    public core: string;
    public subCore: Characteristic;
    public subCoreID?: number;
    public sort: number;
    public sortCalc: number;
    public styleConstraints: StyleConstraint[];
    public styleCharacteristicForces: StyleCharacteristicForce[];
    public secondaryStyleID: number;
    public secondaryStyle: Style;
    public tertiaryStyleID: number;
    public tertiaryStyle: Style;
    public leastPreferredStyleID: number;
    public leastPreferredStyle: Style;
    public surveyVersion: SurveyVersion;
    public surveyVersionID: number;
    public styleTexts: StyleText[];
    public styleTags: StyleTag[];
    public showModal: boolean;
    public useSecondaryStyle: boolean;
}


// WEBPACK FOOTER //
// ./src/models/Style.tsx